import React from 'react';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  download: {
    id: 'Download',
    defaultMessage: 'Scarica',
  },
});

interface DownloadProps {
  file: object;
  title?: string;
  className?: string;
}

export const hasDownload = (file) => {
  return file?.download;
};

const DownloadButton: React.FC<DownloadProps> = ({
  file,
  title,
  className,
}) => {
  const intl = useIntl();
  if (!file || !hasDownload(file)) {
    return null;
  }

  const label = title ?? intl.formatMessage(messages.download);

  return (
    <div className="download-button">
      <UniversalLink href={flattenToAppURL(file.download)}>
        {label}
      </UniversalLink>
    </div>
  );
};

export default DownloadButton;
